<template>
  <div class="master_admin_pathway manager_dashboard" ref="elementToDetectOutsideClick">
    <UserMenu></UserMenu>
    <div class="wrapper">
			<masteradmin-sidebar-menu />
      <div class="content-wrapper"  style="background-color: #FFF;">
        <div class="container-wrapper center" >
          <div>
            <div style="width: 70%; float: left; text-align: left; ">
              <h3 class="d-inline heading">Pathway Builder</h3>
            </div>
						<div style="width: 30%; float: left; text-align: right; ">
							&nbsp;
						</div>
            <div style="clear: both;"></div>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

					<div class="row">
						<div class="col-6 p-0">

							<div class="col-12 pt-1">
								<div class="col-6 p-0 float-left">
									<nav id="sidebar1" 
										class="show_back_button"
									>
										<ul class="list-unstyled" @click="backToPathwayListsPage()">
											<li class="back_button_heading" style="cursor: pointer;" >
												
													<img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" style="margin-top: -3px !important;" />
													{{ pathwayName }}
												
											</li>
										</ul>
									</nav>
								</div>
								<div class="col-6 p-0 mt-1 float-right text-right" v-if="pathway_step_obj.steps.length > 0">
									<button class="btn btn-red btn-md input-height-15 font-13 step-buttons show_button_right_margin" style="text-transform: capitalize;" @click="onSubmit()"
										>Save Pathway</button>
								</div>
								<div style="clear: both;"></div>
							</div>

						</div>
					</div>


					<div class="row">
						<div class="col-6 p-0" v-if="stepLoading == false">

							<div class="row">
								<div class="col pt-2">
									<div v-for="(step, index) in pathway_step_obj.steps" v-if="step.stepTitle" @dragover.prevent @drop="onDrop">
										<div class="pathways_step rounded shadow mb-0 " >
											<div class="row">
												<div class="col-9 font-weight-bold text-left">
													&nbsp;
												</div>
												<div class="col-3 text-right" >
													<div class="px-0 pt-2 step-index mr-4" style="color: #778182;">Step {{ parseInt(index + 1) }}</div>
												</div>
												<div class="col-12 text-right pr-4">
												</div>
											</div>
											<div class="row mt-2" >
												<div class="col-9 font-weight-bold text-left" style="color: #778182;">
													<div class="px-4 pt-0">
														{{ step.stepTitle }} 
													</div>

												</div>
												<div class="col-3 text-right">
													<i class="ml-1 mr-1 fa fa-pencil cursor-pointer text-primary pencilIcon" style="color: #00ACEE !important; font-size: 15px !important;" aria-hidden="true" @click="editStepDetails(index)" ></i>
													<i class="ml-1 mr-4 fa fa-close text-primary removeIcon cursor-pointer" style="font-size: 15px;" aria-hidden="true" @click="deleteStepConfirm(index)" ></i>													
												</div>
											</div>
										</div>


										<!-- Pathway Objective -->
										<div v-for="(objective, oindex) in step.objective" >
										<div class="pathways_ojective_step rounded mb-0 " :class="(step.objective.length == parseInt(oindex + 1)) ? 'no_border' : ''">
											<div class="row" style="padding-top: 5px !important;">
												<div class="col-10">
													<div class="pl-3 py-2">{{ objective.objectiveName }}</div>
												</div>
												<div class="col-2 text-center">
													<button type="button" class="close mt-2 mr-4" aria-label="Close" @click="deleteObjectiveConfirm(index, oindex)">
														<span aria-hidden="true">&times;</span>
													</button>
												</div>
											</div>
										</div>
										</div>
										<!-- End Pathway Objective -->

										<div class="add_objective rounded shadow mb-3" v-if="step.objective.length >= 1">
											<div class="row">
												<div class="col-12">
													<div class="pl-3 py-2 text-center bold cursor-pointer text-uppercase" style="padding-top: 30px !important;"><a class="font-color-00acee" @click="addNewObjective(index)">+ Add an Objective</a></div>
												</div>
											</div>
										</div>
										<div class="add_objective_1 rounded shadow mb-3" v-else>
											<div class="row">
												<div class="col-12">
													<div class="pl-3 py-2 text-center bold cursor-pointer text-uppercase" style="padding-top: 30px !important;"><a class="font-color-00acee" @click="addNewObjective(index)">+ Add an Objective</a></div>
												</div>
											</div>
										</div>

									</div>
									<div style="width:94%; text-align: center;" v-if="pathway_step_obj.steps.length >= 1">
										<div class="text-center col p-0 mb-5 mt-4" style="">
											<button class="btn btn-red btn-md input-height-15 font-13 step-buttons" @click="createStepDetails()">Add Step</button>
										</div>
									</div>
									<div style="width:94%; text-align: center;" v-else>
										<div class="text-left col pr-0 mb-5 mt-4" style="">
											<button class="btn btn-red btn-md input-height-15 font-13 step-buttons" @click="createStepDetails()">Add Step</button>
										</div>
									</div>
								</div>

							</div>

						</div>

						

						<div class="col-6 p-0 font-13 pr-0 fixed-objective" style="" v-if="addObjectiveModalVisible == true">

							<div class="card bg-white pt-4">
								<div class="card-body pl-3 fixed-objective-panel"  style="">
									<div class="pathway_objective_heading col-lg-8 p-0 col-12 float-left" style="padding-top: 1px !important;">
										<h6 class="card-title bold float-left">Drag pathway objectives from the catalog below:</h6>
									</div>
									<div class="pathway_objective_filter col-xl-3 col-lg-3 p-0 col-8 float-left pathway_catalog">
										<b-form-select
											class="input-text"
											v-model="search_affiliate"
											:options="affiliate_options"
											@change="filterByAffiliate()"
										>
										</b-form-select>
									</div>
									<div class="pathway_objective_close col-xl-1	 col-1 p-0 float-left text-right" style="padding-top: 1px !important;">
										<button type="button" class="close float-right mr-3" aria-label="Close" @click="closeObjectiveModal()">
											<span aria-hidden="true">&times;</span>
										</button>
									</div>
									<div class="clearfix"></div>

									<div class="subtask-wrapper" id="subtask-wrapper-1" style="padding-bottom: 5px;">
										<div class="panel-title focused-section-highlight">
											<div class="row m-0" >
												<div class="col-2 p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
													<b-link
														v-b-toggle="collapse-1" class="p-0"  style="font-size: 16px !important; padding-left: 10px !important;" @click="getFocusedSecondFontIcon(1)">
														<img class="mr-2 ml-4" style="" height="17px" src="@/assets/manager/tasks_icon_rep_audit_trail.png" />
													</b-link>
												</div>
												<div class="col-8 p-0">
													<b-link
														v-b-toggle="collapse-1" class="p-0"  style="font-size: 16px !important; padding-left: 10px !important;" @click="getFocusedSecondFontIcon(1)">
															Courses
													</b-link>
												</div>
												<div class="col-2 p-0 text-right pr-4">
													<b-link 
														v-b-toggle="collapse-1" class="p-0 angle_class_font"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIcon(1)">
															<i class="fa fa-angle-right angle-class" id="angle-1" aria-hidden="true" ></i>
													</b-link>
												</div>
											</div>
										</div>
										<b-collapse id="collapse-1" class="mt-2 " style="">
											<b-card>
												<div  class="d-flex flex-wrap report-panel-container  col-md-12 override-padding counter_heading-list heading-wrapper" >
													<div class="col-12 p-0 pl-2 pr-0 search_right_padding " >
														<div class="input-group search_tasks_txtbox mb-2">
															<input type="text" class="form-control" placeholder="Search Courses" v-model="searchCourseText" aria-label="Search tasks" @keyup.enter="docoursesearch()" />
															<div class="input-group-append">
																<span class="input-group-text" v-if="searchCourseTextFlag"><i class="fa fa-close" aria-hidden="true" @click="clearourseCText()"></i></span>
																<span class="input-group-text" v-else><i class="fa fa-search" aria-hidden="true" @click="docoursesearch()"></i></span>
															</div>
														</div>
													</div>
												</div>
												<div class="d-flex flex-wrap report-panel-container col-md-12 override-padding counter_heading-list heading-wrapper" >
													<div class="col-4 p-0" v-for="(course, cindex) in courseOptions">
														<div class="objective-panel rounded text-center nav-item ml-2" draggable="true" @dragstart="startDrag($event, course, 'Course')">
															<i class="fa fa-check-circle-o h5 font-22  mt-2 mb-0 " style="font-size: 21px !important; margin-top: 12px !important;" aria-hidden="true"></i>
															<p class="mb-0 bold line-height-15">{{ course.text }}</p>
														</div>
													</div>
												</div>
												<div class="text-center col-md-12 override-padding counter_heading-list heading-wrapper" v-if="courseOptions.length == 0 && courseLoading == false">
													No Courses Found!
												</div>
												<div class="d-flex flex-wrap report-panel-container col-md-12 override-padding counter_heading-list heading-wrapper" v-if="courseLoading == true">
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
												</div>

												<div style="clear: both;"></div>
											</b-card>
										</b-collapse>

									</div>

									<div class="subtask-wrapper" id="subtask-wrapper-2" style="padding-bottom: 5px;">
										<div class="panel-title focused-section-highlight">
											<div class="row m-0" >
												<div class="col-2 p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
													<b-link
														v-b-toggle="collapse-2" class="p-0"  style="font-size: 16px !important; padding-left: 10px !important;" @click="getFocusedSecondFontIcon(1)">
														<img class="mr-2 ml-4" style="" height="17px" src="@/assets/manager/tasks_icon_rep_audit_trail.png" />
													</b-link>
												</div>
												<div class="col-8 p-0">
													<b-link
														v-b-toggle="collapse-2" class="p-0"  style="font-size: 16px !important; padding-left: 10px !important;" @click="getFocusedSecondFontIcon(2)">
															Assessments
													</b-link>
												</div>
												<div class="col-2 p-0 text-right pr-4">
													<b-link 
														v-b-toggle="collapse-2" class="p-0 angle_class_font"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIcon(2)">
															<i class="fa fa-angle-right angle-class" id="angle-2" aria-hidden="true" ></i>
													</b-link>
												</div>
											</div>
										</div>
										<b-collapse id="collapse-2" class="mt-2 " style="">
											<b-card>
												<div class="d-flex flex-wrap report-panel-container  col-md-12 override-padding counter_heading-list heading-wrapper" >
													<div class="col-4 p-0" v-for="(assessment, cindex) in assessmentOptions" >
														<div class="objective-panel rounded text-center nav-item ml-2" draggable="true" @dragstart="startDrag($event, assessment, 'Assessment')">
															<i class="fa fa-check-circle-o h5 font-22  mt-2 mb-0 " style="font-size: 21px !important; margin-top: 12px !important;" aria-hidden="true"></i>
															<p class="mb-0 bold line-height-15">{{ assessment.text }}</p>
														</div>
													</div>
												</div>
												<div class="text-center col-md-12 override-padding counter_heading-list heading-wrapper" v-if="assessmentOptions.length == 0 && assessmentLoading == false">
													No Assessments Found!
												</div>
												<div class="d-flex flex-wrap report-panel-container col-md-12 override-padding counter_heading-list heading-wrapper" v-if="assessmentLoading == true">
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
												</div>

												<div style="clear: both;"></div>
											</b-card>
										</b-collapse>

									</div>

									<div class="subtask-wrapper" id="subtask-wrapper-3" style="padding-bottom: 5px;">
										<div class="panel-title focused-section-highlight">
											<div class="row m-0" >
												<div class="col-2 p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
													<b-link
														v-b-toggle="collapse-3" class="p-0"  style="font-size: 16px !important; padding-left: 10px !important;" @click="getFocusedSecondFontIcon(1)">
														<img class="mr-2 ml-4" style="" height="17px" src="@/assets/manager/tasks_icon_rep_audit_trail.png" />
													</b-link>
												</div>
												<div class="col-8 p-0">
													<b-link
														v-b-toggle="collapse-3" class="p-0"  style="font-size: 16px !important; padding-left: 10px !important;" @click="getFocusedSecondFontIcon(3)">
															Skill Sets
													</b-link>
												</div>
												<div class="col-2 p-0 text-right pr-4">
													<b-link 
														v-b-toggle="collapse-3" class="p-0 angle_class_font"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIcon(3)">
															<i class="fa fa-angle-right angle-class" id="angle-3" aria-hidden="true" ></i>
													</b-link>
												</div>
											</div>
										</div>
										<b-collapse id="collapse-3" class="mt-2 " style="">
											<b-card>
												<div  class="d-flex flex-wrap report-panel-container  col-md-12 override-padding counter_heading-list heading-wrapper" >
													<div class="col-12 p-0 pl-2 pr-0 search_right_padding " >
														<div class="input-group search_tasks_txtbox mb-2">
															<input type="text" class="form-control" placeholder="Search Skill Sets" v-model="searchText" aria-label="Search tasks" @keyup.enter="dosearch()" />
															<div class="input-group-append">
																<span class="input-group-text" v-if="searchTextFlag"><i class="fa fa-close" aria-hidden="true" @click="clearText()"></i></span>
																<span class="input-group-text" v-else><i class="fa fa-search" aria-hidden="true" @click="dosearch()"></i></span>
															</div>
														</div>
													</div>
												</div>
												<div class="d-flex flex-wrap report-panel-container  col-md-12 override-padding counter_heading-list heading-wrapper" >
													<div class="col-4 p-0" v-for="(tasklist, cindex) in tasklistOptions"  >
														<div class="objective-panel rounded text-center nav-item ml-2" draggable="true" @dragstart="startDrag($event, tasklist, 'Task List')">
															<i class="fa fa-check-circle-o h5 font-22  mt-2 mb-0 " style="font-size: 21px !important; margin-top: 12px !important;" aria-hidden="true"></i>
															<p class="mb-0 bold line-height-15">{{ tasklist.text }}</p>
														</div>
													</div>
												</div>
												<infinite-loading v-if="totalPage > 1" @infinite="infiniteHandler"></infinite-loading>
												<div class="text-center col-md-12 override-padding counter_heading-list heading-wrapper" v-if="tasklistOptions.length == 0 && tasklistLoading == false">
													No Skill Sets Found!
												</div>
												<div class="d-flex flex-wrap report-panel-container col-md-12 override-padding counter_heading-list heading-wrapper" v-if="tasklistLoading == true">
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
												</div>
												<div style="clear: both;"></div>
											</b-card>
										</b-collapse>

									</div>

									<div class="subtask-wrapper" id="subtask-wrapper-4" style="padding-bottom: 5px;">
										<div class="panel-title focused-section-highlight">
											<div class="row m-0" >
												<div class="col-2 p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
													<b-link
														v-b-toggle="collapse-4" class="p-0"  style="font-size: 16px !important; padding-left: 10px !important;" @click="getFocusedSecondFontIcon(1)">
														<img class="mr-2 ml-4" style="" height="17px" src="@/assets/manager/tasks_icon_rep_audit_trail.png" />
													</b-link>
												</div>
												<div class="col-8 p-0">
													<b-link
														v-b-toggle="collapse-4" class="p-0"  style="font-size: 16px !important; padding-left: 10px !important;" @click="getFocusedSecondFontIcon(4)">
															Certifications
													</b-link>
												</div>
												<div class="col-2 p-0 text-right pr-4">
													<b-link 
														v-b-toggle="collapse-4" class="p-0 angle_class_font"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIcon(4)">
															<i class="fa fa-angle-right angle-class" id="angle-4" aria-hidden="true" ></i>
													</b-link>
												</div>
											</div>
										</div>
										<b-collapse id="collapse-4" class="mt-2 " style="">
											<b-card>
												<div class="d-flex flex-wrap report-panel-container col-md-12 override-padding counter_heading-list heading-wrapper" >
														<div class="col-4 p-0" v-for="(certificate, cindex) in certificateOptions" >
														<div class="objective-panel rounded text-center nav-item ml-2" draggable="true" @dragstart="startDrag($event, certificate, 'Certificate')">
															<i class="fa fa-check-circle-o h5 font-22  mt-2 mb-0 " style="font-size: 21px !important; margin-top: 12px !important;" aria-hidden="true"></i>
															<p class="mb-0 bold line-height-15">{{ certificate.text }}</p>
														</div>
													</div>
												</div>
												<div class="text-center col-md-12 override-padding counter_heading-list heading-wrapper" v-if="certificateOptions.length == 0 && certificateLoading == false">
													No Certifications Found!
												</div>
												<div class="d-flex flex-wrap report-panel-container col-md-12 override-padding counter_heading-list heading-wrapper" v-if="certificateLoading == true">
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
													<div class="col-4 p-0  pt-2 pr-1" >
														<div class="rounded text-center nav-item ml-2">
															<PuSkeleton height="85px" :count="1"></PuSkeleton>
														</div>
													</div>
												</div>
												<div style="clear: both;"></div>
											</b-card>
										</b-collapse>

									</div>

								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>








		<CreatePathwayStepModal :isModalVisible="addStepModalVisible" @close="addStepModalVisible = false">
			<div slot="header" class="sub-heading m-0"><h6 class="modal-title">{{ getStepTitlValue(stepIndex) }} Step</h6></div>
			<div slot="body" v-if="addStepModalVisible == true">
				<div class="col-12 override-padding">
					<div class="col-12 override-padding form-group">
						<label class="input_label" for="pathway_name">Name:<span class="required">*</span></label>
						<input v-model="stepTitle"
									name="stepTitle"
									placeholder="Name the step (i.e. Mentee, Entry-level or C-Tech)"
									class="col-lg-12 input-text form-control line-height-30"
									v-validate="'required'"
									maxlength="140" />
						<div v-if="verrors.firstByRule('stepTitle', 'required')" class="margin-bottom-5 validate-warning-msg">Step Name is required</div>
					</div>
					<div class="col-12 override-padding form-group">
						<label class="input_label" for="stepDescription">Description:</label>
						<textarea
							name="stepDescription" 
							v-model="stepDescription"
							placeholder="Describe what skills this step will focus on."
							class="textarea col-xs-12 input-text col-md-12 col-lg-12 input-height-25 form-control"
							maxlength="500" style="resize: none; height: 80px;">
							</textarea>
					</div>

				</div>
			</div>
			<div slot="footer" class="col-12  pt-5 p-0 text-center">
				<button type="submit" class="btn btn-red btn-md input-height-15 pathway_save_btn" @click="onCreateStep()">Save</button>
			</div>
		</CreatePathwayStepModal>

		<DeleteModal :isModalVisible="isDeleteModalVisible"  @close="isDeleteModalVisible = false">
			<span v-if="loading" class="pull-right text-danger">
				Loading...
			</span>
			<div slot="header" class="sub-heading">{{ deleteMessage }}</div>
			<div slot="body">

			</div>
			<div slot="footer" class="col-3 override-padding">
				<button class="col-12 btn btn-red" style="border-radius: 0 !important; " @click="isDeleteModalVisible = false; deleteAction()">Confirm</button>
			</div>
		</DeleteModal>

	</div>



</template>
<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import UserMenu from '@/components/shared/user_menu.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";
import router from '../../router/index.js';
import CreatePathwayStepModal from '../manager/create-pathway-modal.vue';
import EditPathwayStepModal from '../manager/create-pathway-modal.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import InfiniteLoading from 'vue-infinite-loading';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const stepTitleValue = ["First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth", "Tenth"];

export default {
        data() {
          return {
						pathwayId: '',
						pathway_step_obj: {
							pathway: [],
							steps: [],
							removed_objective: [],
							removed_step: [],
							flag: 'Insert',
						},
						pathwayName: '',
						addStepModalVisible: false,
						addObjectiveModalVisible: false,
						stepTitle: '',
						stepDescription: '',
						stepIndex: '',
						objectiveIndex: '',
						objectiveType: '',
						objectiveId: '',
						objectiveLoading: false,
						objectiveOptions: [],
						assessmentOptions: [],
						courseOptions: [],
						tasklistOptions: [],
						certificateOptions: [],
            isDeleteModalVisible: false,
						deleteList: '',
						deleteMessage: '',
						isopenPathwayCatalogBuilderVisible: false,
						loading: false,
						pathway_catalog_flag: 0,
						alertFlag: 0,
						stepLoading: false,
						assessmentLoading: false,
						courseLoading: false,
						tasklistLoading: false,
						certificateLoading: false,
						searchTextFlag: false,
						searchText: '',
						page: 1,	
						totalPage: '',
						totaltasklistItem: [],
						displayItemCount: 20,
            affiliate_options: [],
            search_affiliate: '',
						getObjectiveTypeForAffiliateSearch: '',
						searchCourseTextFlag: false,
						searchCourseText: '',
	        }
        },
        components: {
					UserMenu,
					MasteradminSidebarMenu,
					CreatePathwayStepModal,
					EditPathwayStepModal,
	        DeleteModal,
					InfiniteLoading,
        },
        beforeRouteLeave(to, from, next) {
          if (this.alertFlag == 1 && !confirm('Changes that you made to the pathway is not saved. Please save before leaving.')) 
					{
            next(false);
						this.alertFlag = 0;
					}
          else {
						next()
					}
        },
				mounted() {

				},
        methods: {
					filterByAffiliate() {
						if(this.getObjectiveTypeForAffiliateSearch == 'Task List') {
							this.getObjectiveOptions('Task List');
						}
						else if(this.getObjectiveTypeForAffiliateSearch == 'Course') {
							this.getObjectiveOptions('Course');
						}
					},
					infiniteHandler($state) {
						setTimeout(() => {
							if(this.page >= this.totalPage) {
								$state.complete();
							}
							else {
								this.page += 1;
								axios('/master-admin-pathway-catalog/tasklists',
									{
										method: 'GET',
										params: {
											searchText: this.searchText,
											page: this.page,
											affiliate: this.search_affiliate,
										}
									},
								)
								.then(response => {
									this.totaltasklistItem = response.data.data;
									for(var i=0; i < this.totaltasklistItem.length; i++) {
										if(this.totaltasklistItem[i]) {
											var tasklistItem = {id: this.totaltasklistItem[i].id, text: this.totaltasklistItem[i].name};
											this.tasklistOptions.push(tasklistItem);
										}
									}
									$state.loaded();
									if(this.page >= this.totalPage) {
										$state.complete();
									}
								})
								.catch(error => {

								});
							}
						}, 100);
					},
					clearourseCText() {
						this.searchCourseText = '';
						this.searchCourseTextFlag = false;
						this.getObjectiveOptions('Course');
					},
					clearText() {
						this.searchText = '';
						this.searchTextFlag = false;
						this.page = 1;
						this.getObjectiveOptions('Task List');
					},
					docoursevalidate() {
						var flag = 1;
						if(this.searchCourseText == '') {
							alert("Please enter search text");
							flag = 0;
							return false;
						}
						if(this.searchCourseText.length < 3) {
							alert("Search text should be minimum 3 characters");
							flag = 0;
							return false;
						}
						return flag;
					},
					docoursesearch() {
						var flag = this.docoursevalidate();
						if(flag == 1) {
							this.searchCourseTextFlag = true;
							this.courseOptions = [];
							this.courseLoading = true;
							axios.get('/master-admin-pathway-catalog/course-lists', {
								params: {
									user_roles: 'ROLE_MENTEE',
									searchText: this.searchCourseText,
									affiliate: this.search_affiliate,
								},
							})
							.then(response =>  {
								for(var i=0; i < response.data.length; i++) {
									var group = {id: response.data[i].value, text: response.data[i].name};
									this.courseOptions.push(group);
								}
								this.objectiveLoading = false;
								this.courseLoading = false;
							})
							.catch(function(error) {
								console.log(error);
							});

						}
					},
					dovalidate() {
						var flag = 1;
						if(this.searchText == '') {
							alert("Please enter search text");
							flag = 0;
							return false;
						}
						if(this.searchText.length < 3) {
							alert("Search text should be minimum 3 characters");
							flag = 0;
							return false;
						}
						return flag;
					},
					dosearch() {
						var flag = this.dovalidate();
						this.page = 1;
						if(flag == 1) {
							this.searchTextFlag = true;
							this.tasklistOptions = [];
							this.tasklistLoading = true;

							axios('/master-admin-pathway-catalog/tasklists',
								{
									method: 'GET',
									params: {
										searchText: this.searchText,
										page: this.page,
										affiliate: this.search_affiliate,
									}
								},
							)
							.then(response => {
								this.totaltasklistItem = response.data.data;
								this.totalPage = response.data.total_pages;
								for(var i=0; i < this.totaltasklistItem.length; i++) {
									if(this.totaltasklistItem[i]) {
										var tasklistItem = {id: this.totaltasklistItem[i].id, text: this.totaltasklistItem[i].name};
										this.tasklistOptions.push(tasklistItem);
									}
								}
								this.objectiveLoading = false;
								this.tasklistLoading = false;
							})
							.catch(error => {

							});
						}
					},
					PathwayCatalogFlag(flag) {
						this.pathway_catalog_flag = flag;
					},
					openPathwayCatalogBuilder() {
						this.isopenPathwayCatalogBuilderVisible = true;
						this.$refs.PathwayCatalogBuilderRef.openPathwayBuilderCatalogModal();
					},
					truncate: function (text) {
						if (text.length > 20) {
								return text.substring(0, 20) + '...';
						} else {
								return text;
						}
					},
					getStepTitlValue(index) {
						return stepTitleValue[index];
					},
					doValidateStepTitle() {
						var flag = 0;
						for(var i=0; i < this.pathway_step_obj.steps.length; i++) {
							if(this.pathway_step_obj.steps[i].stepTitle == '') {
								flag = 1;
								alert("Please add step title for step - " + parseInt(i+1));
							}
						}
						return flag;
					},
					onSubmit() {
						var flag = this.doValidateStepTitle();
						if(flag == 0) {
							this.alertFlag = 0;
							axios('/post-pathway-step-details',
								{
									method: 'POST',
									data:
										{
											pathway_step_obj: this.pathway_step_obj,
										},
								}
							)
							.then((resp) => {
									this.backToPathwayListsPage();
									
							})
							.catch(error => {
								if(error.response.data.message == 'Access denied.') {
									router.push("/forbidden");
								}
							});
						}

					},
					backToPathwayListsPage() {
						router.push("/masteradmin-pathway-catalog");
					},
					deleteStepConfirm: function(stepIndex) {
						this.deleteMessage = 'Are you sure you want to delete? This will delete the step and the related objective.';
						this.stepIndex = stepIndex;
						this.deleteList = 'Step';
						this.isDeleteModalVisible = true;
					},
					deleteObjectiveConfirm: function(stepIndex, objectiveIndex) {
						this.deleteMessage = 'Are you sure you want to delete? This will delete the objective.';
						this.stepIndex = stepIndex;
						this.objectiveIndex = objectiveIndex;
						this.deleteList = 'Objective';
						this.isDeleteModalVisible = true;
					},
					deleteAction: function() {
						this.alertFlag = 1;
						if(this.deleteList == 'Objective') {
							this.removeObjective(this.stepIndex, this.objectiveIndex);
						}
						else {
							this.removeStep(this.stepIndex);
							this.closeObjectiveModal();
						}
					},
					removeStep(stepIndex) {
						if(this.pathway_step_obj.steps[stepIndex].update == true) {
							this.pathway_step_obj.removed_step.push({
								step_id: this.pathway_step_obj.steps[stepIndex].id,
							});
						}
						this.pathway_step_obj.steps.splice(stepIndex, 1);
						this.$store.dispatch('pathway_steps', this.pathway_step_obj);
					},
					removeObjective(stepIndex, objectiveIndex) {
						if(this.pathway_step_obj.steps[stepIndex].objective[objectiveIndex].update == true) {
							this.pathway_step_obj.removed_objective.push({
								objective_id: this.pathway_step_obj.steps[stepIndex].objective[objectiveIndex].id,
							});
						}
						this.pathway_step_obj.steps[stepIndex].objective.splice(objectiveIndex, 1);
						this.$store.dispatch('pathway_steps', this.pathway_step_obj);
					},
					onDrop(event) {
						const itemContent = event.dataTransfer.getData('itemContent');
						const receivedArray = JSON.parse(itemContent);
						let id = receivedArray.id;
						let text = receivedArray.text;
						this.addObjective(id, text);
						this.objectiveType = event.dataTransfer.getData('type');
					},
					startDrag(event, item, type) {
						const jsonString = JSON.stringify(item);
						event.dataTransfer.setData('type', type);
						event.dataTransfer.setData('itemContent', jsonString);
						event.dataTransfer.dropEffect = 'move';
						event.dataTransfer.effectAllowed = 'all';
					},  
					doValidateObjective(id, type) {
						var flag = 0;
						if((type == 'Assessment') || (type == 'Course')) {
							for(var x=0; x < this.pathway_step_obj.steps[this.stepIndex].objective.length; x++) {
								if((id == this.pathway_step_obj.steps[this.stepIndex].objective[x].objectiveId) && (this.pathway_step_obj.steps[this.stepIndex].objective[x].objectiveType == type)) {
									if(type == 'External Course') {
										type = 'Course';
									}
									if(type == 'Task List') {
										type = 'Skill Set';
									}
									flag = 1;
									alert("This "+type+" is already exists in this step");
								}
							}
						}
						else {
							for(var i=0; i < this.pathway_step_obj.steps.length; i++) {
								for(var x=0; x < this.pathway_step_obj.steps[i].objective.length; x++) {
									if((id == this.pathway_step_obj.steps[i].objective[x].objectiveId) && (this.pathway_step_obj.steps[i].objective[x].objectiveType == type)) {
										var typedisplay = type;
										if(type == 'Task List') {
											typedisplay = 'Skill Set';
										}
										flag = 1;
										alert("This "+typedisplay+" is already exists in this pathway");
									}
								}
							}
						}
						return flag;
					},
					addObjective(id, text) {
						this.alertFlag = 1;
						/* Check option already exists */
						if(this.objectiveType == 'Course' || this.objectiveType == 'External Course') {
							var idd = id.split('-');
							if(idd[0] == 'E') {
								id = idd[1];
								this.objectiveType = 'External Course'
							}
							else {
								id = idd[1];
								this.objectiveType = 'Course'
							}
						}

						var flag = this.doValidateObjective(id, this.objectiveType);
						if(flag == 0) {
							this.pathway_step_obj.steps[this.stepIndex].objective.push({
								'id': '',
								'objectiveType': this.objectiveType,
								'objectiveId': id,
								'objectiveName': text,
								'edit': false,
								'update': false,
								'modified': false,
							});
							this.$store.dispatch('pathway_steps', this.pathway_step_obj);
						}
					},
					closeObjectiveModal() {
						this.stepTitle = '';
						this.objectiveOptions = [];
						this.objectiveId = '';
						this.objectiveType = '';
						this.stepIndex = '';
						this.addObjectiveModalVisible = false;
						this.getObjectiveTypeForAffiliateSearch = '';
						this.search_affiliate = '';
					},
					addNewObjective(stepIndex) {
						this.closeObjectiveModal();
						setTimeout(() => {
							this.stepIndex = stepIndex;
							this.objectiveOptions = [];
							this.objectiveId = '';
							this.objectiveType = '';
							this.addObjectiveModalVisible = true;
							this.search_affiliate = '';
							this.getObjectiveTypeForAffiliateSearch = '';
						}, 500);
					},
					getObjectiveOptions(type) {
						this.objectiveLoading = true;
						this.objectiveType = type;
						if(this.objectiveType == 'Assessment') {
							this.assessmentOptions = [];
							this.assessmentLoading = true;
							axios.get('/master-admin-pathway-catalog/assessment-lists', {
								params: {
									user_roles: 'ROLE_MENTEE',
								},
							})
							.then(response =>  {
								for(var i=0; i < response.data.length; i++) {
									var group = {id: response.data[i].value, text: response.data[i].name};
									this.assessmentOptions.push(group);
								}
								this.objectiveLoading = false;
								this.assessmentLoading = false;
							})
							.catch(function(error) {
								console.log(error);
							});

						} else if(this.objectiveType == 'Course') {
							this.courseOptions = [];
							this.courseLoading = true;
							axios.get('/master-admin-pathway-catalog/course-lists', {
								params: {
									user_roles: 'ROLE_MENTEE',
									searchText: this.searchCourseText,
									affiliate: this.search_affiliate,
								},
							})
							.then(response =>  {
								for(var i=0; i < response.data.length; i++) {
									var group = {id: response.data[i].value, text: response.data[i].name};
									this.courseOptions.push(group);
								}
								this.objectiveLoading = false;
								this.courseLoading = false;
							})
							.catch(function(error) {
								console.log(error);
							});
						} else if(this.objectiveType == 'Task List') {
							this.tasklistOptions = [];
							this.page = 1;
							this.tasklistLoading = true;
							axios('/master-admin-pathway-catalog/tasklists',
								{
									method: 'GET',
									params: {
										page: this.page,
										affiliate: this.search_affiliate,
										searchText: this.searchText,
									}

								},
							)
							.then(response => {
								this.totaltasklistItem = response.data.data;
								this.totalPage = response.data.total_pages;
								for(var i=0; i < this.totaltasklistItem.length; i++) {
									if(this.totaltasklistItem[i]) {
										var tasklistItem = {id: this.totaltasklistItem[i].id, text: this.totaltasklistItem[i].name};
										this.tasklistOptions.push(tasklistItem);
									}
								}
								this.objectiveLoading = false;
								this.tasklistLoading = false;
							})
							.catch(error => {

							});
						} else if(this.objectiveType == 'Certificate') {
							this.certificateOptions = [];
							this.certificateLoading = true;
							axios.get('/master-admin-pathway-catalog/certification-lists', {
							})
							.then(response =>  {
								for(var i=0; i < response.data.length; i++) {
									var group = {id: response.data[i].id, text: response.data[i].text};
									this.certificateOptions.push(group);
								}
								this.objectiveLoading = false;
								this.certificateLoading = false;
							})
							.catch(function(error) {
								console.log(error);
							});

						}

					},

					getFocusedSecondFontIcon(id) {
						if (document.getElementById('collapse-' + id).style.display == "block") {
							document.getElementById('angle-'+ id).className = "fa fa-angle-right angle-class";
							document.getElementById('subtask-wrapper-'+ id).className = "subtask-wrapper";
							document.getElementById('collapse-' + id).style.display = "";
						} else {
							document.getElementById('angle-'+ id).className = "fa fa-angle-down angle-class";
							document.getElementById('subtask-wrapper-'+ id).className = "subtask-wrapper";
							if(id == 1) {
								var idd = 2;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								var idd = 3;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								var idd = 4;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								this.getObjectiveOptions('Course');
								this.getObjectiveTypeForAffiliateSearch = 'Course';
							}
							if(id == 2) {
								this.getObjectiveOptions('Assessment');
								this.getObjectiveTypeForAffiliateSearch = 'Assessment';
								var idd = 1;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								var idd = 3;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								var idd = 4;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
							}
							if(id == 3) {
								this.getObjectiveOptions('Task List');
								this.getObjectiveTypeForAffiliateSearch = 'Task List';
								var idd = 1;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								var idd = 2;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								var idd = 4;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
							}
							if(id == 4) {
								this.getObjectiveOptions('Certificate');
								this.getObjectiveTypeForAffiliateSearch = 'Certificate';
								var idd = 1;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								var idd = 2;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
								var idd = 3;
								document.getElementById('angle-'+ idd).className = "fa fa-angle-right angle-class";
								document.getElementById('subtask-wrapper-'+ idd).className = "subtask-wrapper";
								document.getElementById('collapse-' + idd).style.display = "";
							}
							document.getElementById('collapse-' + id).style.display = "block";
						}
					},
					editStepDetails(index) {
						this.stepIndex = index;
						this.stepTitle = this.pathway_step_obj.steps[index].stepTitle;
						this.stepDescription = this.pathway_step_obj.steps[index].stepDescription;
						this.addStepModalVisible = true;
					},
					createStepDetails() {
						var len = this.pathway_step_obj.steps.length;
						if(len == 0) {
							var index = 0;
						}
						else {
							var index = len;
						}
						this.stepIndex = index;
						this.stepTitle = '';
						this.stepDescription = '';
						this.addStepModalVisible = true;
					},
					onCreateStep() {
						this.$validator.validateAll().then((result) => {
						if ((this.verrors.items.length === 0)) {
							this.alertFlag = 1;
							if(this.pathway_step_obj.steps[this.stepIndex]) {
								this.pathway_step_obj.steps[this.stepIndex].stepTitle = this.stepTitle;
								this.pathway_step_obj.steps[this.stepIndex].stepDescription = this.stepDescription;
								if(this.pathway_step_obj.steps[this.stepIndex].update == true) {
									this.pathway_step_obj.steps[this.stepIndex].modified = true;
								}
							}
							else {
                this.pathway_step_obj.steps.push({
                  id: '',
                  stepTitle: this.stepTitle,
                  stepDescription: this.stepDescription,
                  objective: [],
                  edit: false,
                  update: false,
                  modified: false,
                });

							}
							this.stepTitle = '';
							this.stepDescription = '';
							this.stepIndex = '';
							this.addStepModalVisible = false;
							this.$store.dispatch('pathway_steps', this.pathway_step_obj);
						}
						});
						return false;
					},
					getPathwayStepDetails: function() {
						axios.get('/get-pathway-step-details', {
							params: {
								pathwayId: this.pathwayId,
							}
						})
						.then((resp) => {
								this.stepLoading = false;
								this.pathway_step_obj.pathway = resp.data.pathway;
								this.pathwayName = this.pathway_step_obj.pathway.name;
								this.pathway_step_obj.steps = resp.data.pathwayStep;
								this.flag = resp.data.flag;
								if(this.pathway_step_obj.steps.length > 0) {
									this.pathway_step_obj.flag = 'Update';
								}
								this.$store.dispatch('pathway_steps', this.pathway_step_obj);
						})
						.catch(error => {
							if(error.response.data.message == 'Access denied.') {
								router.push("/forbidden");
							}
						});

					},
					fetchAffiliateOptions: function() {
						axios.get('/affiliateoptions', {

						})
						.then((response) => {
								var affiliate_option = {value: '', text: 'Select Affiliate'};
								this.affiliate_options.push(affiliate_option);
								for(var i=0; i < response.data.length; i++) {
									var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
									this.affiliate_options.push(affiliate_option);
								}
						})
						.catch(error => {

						});
					},
				},

				created() {
					this.stepLoading = true;
					this.pathwayId = this.$route.params.pathway_id;
					this.getPathwayStepDetails();
					this.fetchAffiliateOptions();
					this.$store.dispatch('catalog_pathway_steps_flag', '');
				},
}

</script>

<style>
	.back_icon { width: 11px !important; }
	.back_button_heading {
		font-size: 16px;
		color: #646F71;
		font-weight: bold;
	}
	.pathwayBtn, .pathwayBtn:hover, .pathwayBtn:focus {
		padding: 7px 7px; border-radius: 15px !important;
		width: 130px;
	}
	.master_admin_pathway .pathways_step {
		height: 80px;
		width: 80%;
		margin-left: 40px;
		border-top-left-radius: 15px !important;
		border-top-right-radius: 15px !important;
		box-shadow: 0px 0px 5px rgba(0,0,0,.15) !important;
		background-color: #FFF;
		border-bottom-left-radius: 0px !important;
		border-bottom-right-radius: 0px !important;
	}
	.master_admin_pathway .pathways_ojective_step {
		min-height: 65px;
		width: 80.33%;
		margin-left: 39px;
		margin-right: 0;
		border: 0;
		background-color: #E2F3F9;
		padding-top: 10px;
		color: #778182;
		font-size: 13px;
		padding-left: 8px;
		border-bottom: 1px solid #E5E4E2;
		box-shadow: none !important;
		border-radius: 0 !important;
		font-weight: 600;
	}
	.master_admin_pathway .no_border {
		border-bottom: 0 !important;
	}
	.master_admin_pathway .add_objective {
		height: 80px;
		width: 80%;
		margin-left: 40px;
		border-top: 0;
		background-color: #FFF;
		box-shadow: 0px 0px 5px rgba(0,0,0,.15) !important;
		clip-path: inset(0px -10px -10px -10px);
		border-top-left-radius: 0px !important;
		border-top-right-radius: 0px !important;
	}
	.master_admin_pathway .add_objective_1 {
		height: 80px;
		width: 80%;
		margin-left: 40px;
		border-top: 0;
		background-color: #FFF;
		box-shadow: 0px 0px 5px rgba(0,0,0,.15) !important;
		border-top-left-radius: 0px !important;
		border-top-right-radius: 0px !important;
	}
	.step-index {
		color: #778182;
		font-size: 12px;
	}
	.master_admin_pathway .subtask-wrapper {
		margin-top: 15px;
		margin-left: 40px;
		margin-right: 30px;
	}
	.master_admin_pathway .fixed-objective {
		position: fixed; right: 0; left: 55%; top: 11%; height: 100%;
		border-left: 1px solid #dee2e6;
		border-top: 0;
		box-shadow: 0px 0px 3px 0px rgba(0,0,0,.15) !important;
	}
	.master_admin_pathway .fixed-objective-panel {
		margin-bottom: 20px; overflow-y: scroll; height: 650px; margin-right: 90px;
	}
	.objective-panel p {
		font-size: 13px;
	}
	.report-panel-container {
		justify-content: left;
		padding-left: 2rem !important;
		padding-right: 2rem !important;
	}
	.master_admin_pathway .objective-panel {
		border: 1px solid #B2B2B2;
		float: left;
		padding-left: 11px;
		padding-right: 11px;
		color: #646F71 !important;
		width: 90%;
		min-height: 80px;
		margin-bottom: 12px;
		border-radius: 10px !important;
		transform: translate(0, 0); 
		opacity: 1;
	}
	.master_admin_pathway .show_button_right_margin {
		margin-right: 70px !important;
	}
	.master_admin_pathway .search_right_padding {
		padding-right: 8px !important;
	}
	
	@media (max-width: 1690px) and (min-width: 1600px) {
		.master_admin_pathway .show_button_right_margin {
			margin-right: 83px !important;
		}
		.master_admin_pathway .fixed-objective {
			position: fixed; right: 0; left: 53%; top: 9%;
			border-left: 1px solid #dee2e6;
			border-top: 0;
			box-shadow: 0px 0px 3px 0px rgba(0,0,0,.15) !important;
		}
		.master_admin_pathway .fixed-objective-panel {
			margin-bottom: 20px; overflow-y: auto; height: 780px; margin-right: 70px;
		}
	}
	@media (min-width: 1800px) {
		.master_admin_pathway .search_right_padding {
			padding-right: 13px !important;
		}
		.master_admin_pathway .show_button_right_margin {
			margin-right: 100px !important;
		}
		.master_admin_pathway .fixed-objective {
			position: fixed; right: 0; left: 53%; top: 7%;
			border-left: 1px solid #dee2e6;
			border-top: 0;
			box-shadow: 0px 0px 3px 0px rgb1a(0,0,0,.15) !important;
		}
		.master_admin_pathway .fixed-objective-panel {
			margin-bottom: 20px; overflow-y: auto; height: 850px; margin-right: 50px;
		}
	}
	@media (max-width: 1400px) {
		.master_admin_pathway .search_right_padding {
			padding-right: 4px !important;
		}
		.master_admin_pathway .show_button_right_margin {
			margin-right: 50px !important;
		}
		.master_admin_pathway .fixed-objective {
			position: fixed; right: 0; left: 56%; top: 13%; height: 100%;
			border-left: 1px solid #dee2e6;
			border-top: 0;
			box-shadow: 0px 0px 3px 0px rgba(0,0,0,.15) !important;
		}
		.master_admin_pathway .fixed-objective-panel {
			margin-bottom: 20px; overflow-y: scroll; height: 520px; margin-right: 80px;
		}
		.objective-panel p {
			font-size: 12px;
		}
		.report-panel-container {
			justify-content: left;
			padding-left: 0.5rem !important;
			padding-right: 0.5rem !important;
		}
		.master_admin_pathway .objective-panel {
			border: 1px solid #B2B2B2;
			background-color: #FFF;
			float: left;
			padding-left: 10px;
			padding-right: 10px;
			color: #646F71 !important;
			width: 92%;
			min-height: 77px;
			margin-bottom: 12px;
			border-radius: 10px;
			transform: translate(0, 0); 
			opacity: 1;
		}
	}
	.master_admin_pathway .subtask-wrapper .panel-title {
		border: 1px solid #B2B2B2;
		background-color: #FFF;
		float: left;
		width: 100%;
		margin-bottom: 10px;
		border-radius: 10px;
		height: 40px;
		color: #646F71 !important;
	}
	.master_admin_pathway .subtask-wrapper .panel-title a, .master_admin_pathway .subtask-wrapper .panel-title a:hover{
		color: #646F71 !important;
	}
	.master_admin_pathway .subtask-wrapper .panel-title:hover, .master_admin_pathway .subtask-wrapper .panel-title.focus {
		border: 1px solid #E2F3F9;
		background-color: #E2F3F9;
	}
	.master_admin_pathway .subtask-wrapper .panel-title:has(div div a i.fa-angle-down) {
		background-color: #E2F3F9;
		border: 1px solid #E2F3F9;
	}

	.angle_class_font {
		font-size: 25px !important;
		margin-top: 0px !important;
		color: #646F71 !important;
	}
	.objective-panel:hover, .objective-panel:focus {
		cursor: grab;
		background-color: #F5F5F5;
		caret-color: purple;
		contenteditable: false;
	}
	.objective-panel:active {
		cursor: grabbing;
		background-color: #F5F5F5 !important;
		caret-color: purple;
		contenteditable: false;
	}
	.line-height-15 {
		line-height: 15px;
	}
	.master_admin_pathway .removeIcon {
		color: #FF0000 !important;
	}
	.master_admin_pathway .removeIcon:hover {
		color: #b13939 !important;
	}

	.master_admin_pathway .objective-panel p {
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
	}
	.search_tasks_txtbox input {
		height: 40px;
		border-right: 0;
		font-size: 14px;
		border-radius: 10px;
		border-color: #002F42 !important;
	}
	.search_tasks_txtbox input:active,
	.search_tasks_txtbox input:focus,
	.search_tasks_txtbox input:hover {
		border-color: #002F42 !important;
		box-shadow: none;
	}
	.search_tasks_txtbox .input-group-text {
		background-color: #FFFFFF;
		color: #00ACEE;
		cursor: pointer;
		border-radius: 10px;
		padding-bottom: 0px;
		padding-top: 0px;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-color: #002F42 !important;
	}
	.pathway_catalog select {
		border-radius: 9px;
		height: 25px;
		padding: 0 0 0 8px;
		border-color: #7F97A0 !important;
		box-shadow: none !important;
	}
	.pathway_objective_heading {
		max-width: 55% !important;
	}
	.pathway_objective_filter {
		max-width: 26% !important;
	}
	.pathway_objective_close {
		max-width: 19% !important;
	}
	@media (min-width: 1800px) {
		.pathway_objective_heading {
			max-width: 42% !important;
		}
		.pathway_objective_filter {
			max-width: 23% !important;
		}
		.pathway_objective_close {
			max-width: 35% !important;
		}
	}
	@media (max-width: 1400px) {
		.pathway_objective_heading {
			max-width: 65% !important;
		}
		.pathway_objective_filter {
			max-width: 27% !important;
		}
		.pathway_objective_close {
			max-width: 8% !important;
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/admin/master_admin_pathway_catalog_step_builder.vue